<div class="modal-content" [ngClass]="{ dangerous: isDangerous }">
    <div class="modal-header">
        {{ title }}
    </div>
    <div class="modal-body" [ngSwitch]="contentType">
        <div *ngSwitchCase="'string'" [innerHTML]="content"> </div>

        <ng-container *ngSwitchCase="'template'">
            <ng-container *ngTemplateOutlet="content; context: context"></ng-container>
        </ng-container>

        <ng-container *ngSwitchCase="'component'">
            <ng-container *ngComponentOutlet="content; injector"></ng-container>
        </ng-container>
    </div>
    <div class="modal-footer" *ngIf="buttons?.length">
        <app-button *ngFor="let button of buttons" [style]="button.type" (click)="onModalButtonClick(button)">
            {{ button.label }}
        </app-button>
    </div>
</div>
